import { render, staticRenderFns } from "./waitBox.vue?vue&type=template&id=31277fdc&scoped=true&"
import script from "./waitBox.vue?vue&type=script&lang=js&"
export * from "./waitBox.vue?vue&type=script&lang=js&"
import style0 from "./waitBox.vue?vue&type=style&index=0&id=31277fdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31277fdc",
  null
  
)

export default component.exports